<section>
    <h1 class="hvac-h2 hvac-rhythm-5">{{'PROFILE.PROFILE' | translate}}</h1>
    <form [formGroup]="profileForm">
        <div class="hvac-row">
            <div class="hvac-col-xs-12 hvac-col-md-6 hvac-profile-col">
                <div class="hvac-form-field">
                    <utc-input [inputControl]="profileForm.controls.userName" [disabledInput]="true"
                        label="{{'GENERAL.LABELS.USER_NAME' | translate}}">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input [inputControl]="profileForm.controls.myHVACpin" [disabledInput]="true"
                        label="{{'GENERAL.LABELS.HVAC_PIN' | translate}}">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input [inputControl]="profileForm.controls.firstName"
                        [error]="(profileForm.controls.firstName.dirty || profileForm.controls.firstName.touched) && !profileForm.controls.firstName.valid"
                        label="{{'GENERAL.LABELS.FIRST_NAME' | translate}}" [max]="40">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input [inputControl]="profileForm.controls.lastName" [max]="40"
                        [error]="(profileForm.controls.lastName.dirty || profileForm.controls.lastName.touched) && !profileForm.controls.lastName.valid"
                        label="{{'GENERAL.LABELS.LAST_NAME' | translate}}">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input inputId="office_number"
                    [label]="('GENERAL.LABELS.OFFICE_PHONE' | translate)"
                    [error]="(profileForm.controls.phone.dirty || profileForm.controls.phone.touched) && !profileForm.controls.phone.valid"
                        [inputControl]="profileForm.controls.phone"
                        [mask]="maskPhoneNumber" [max]="maskPhoneNumber ? 14:20" (input)="onPhoneInput('phone')">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input inputId="mobile_number"
                    [label]="('GENERAL.LABELS.MOBILE_NUMBER' | translate)"
                    [error]="(profileForm.controls.cellPhone.dirty || profileForm.controls.cellPhone.touched) && !profileForm.controls.cellPhone.valid"
                        [inputControl]="profileForm.controls.cellPhone"
                        [mask]="maskPhoneNumber" [max]="20">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input 
                    [error]="(profileForm.controls.email.dirty || profileForm.controls.email.touched) && !profileForm.controls.email.valid"
                    [inputControl]="profileForm.controls.email" [max]="241"
                        label="{{'GENERAL.LABELS.EMAIL' | translate}}">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input inputId="fax_number"
                    [label]="('GENERAL.LABELS.FAX' | translate)"
                    [error]="(profileForm.controls.fax.dirty || profileForm.controls.fax.touched) && !profileForm.controls.fax.valid"
                    [inputControl]="profileForm.controls.fax"
                    [mask]="maskPhoneNumber" [max]="20">
                    </utc-input>
                </div>
            </div>

            <div class="hvac-col-xs-12 hvac-col-md-6">
                <div class="hvac-form-field">
                    <utc-input [inputControl]="profileForm.controls.address1" [max]="60"
                        [error]="(profileForm.controls.address1.dirty || profileForm.controls.address1.touched) && !profileForm.controls.address1.valid"
                        label="{{'GENERAL.LABELS.ADDRESS_1' | translate}}">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input 
                        [error]="(profileForm.controls.address2.dirty || profileForm.controls.address2.touched) && !profileForm.controls.address2.valid"
                        [inputControl]="profileForm.controls.address2" [max]="60"
                        label="{{'GENERAL.LABELS.ADDRESS_2' | translate}}">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input [inputControl]="profileForm.controls.city"
                        [error]="(profileForm.controls.city.dirty || profileForm.controls.city.touched) && !profileForm.controls.city.valid"
                        label="{{'GENERAL.LABELS.CITY' | translate}}" [max]="40">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-select [group]="profileForm" control="country" [selectId]="'selectcountry'"
                    [error]="(profileForm.controls.country.dirty || profileForm.controls.country.touched) && !profileForm.controls.country.valid"
                    [defaultOption]="'GENERAL.LABELS.COUNTRY' | translate" [options]="(countryOptionData$ | async)!">
                    </utc-select>
                </div>

                <div class="hvac-form-field">
                    <utc-select [group]="profileForm" control="state" [selectId]="'selectState'"
                    [error]="!stateListLoading && (profileForm.controls.state.dirty || profileForm.controls.state.touched) && !profileForm.controls.state.valid"
                    [defaultOption]="'GENERAL.LABELS.STATE' | translate" [options]="(stateOptionData$ | async)!">
                    </utc-select>
                </div>

                <div class="hvac-form-field">
                    <utc-input 
                    [error]="(profileForm.controls.zip.dirty || profileForm.controls.zip.touched) && !profileForm.controls.zip.valid"
                    [label]="(placeHolderByCountry$ | async)?.placeHolderZipcode?.label || ('GENERAL.LABELS.ZIP' | translate)"
                    [inputControl]="profileForm.controls.zip"
                    (input)="onPostalCodeInput($event)" [max]="10" inputId="user-validation-input">
                    </utc-input>
                </div>
            </div>
        </div>
    </form>
</section>

<div class="hvac-divider"></div>

<div class="hvac-profile-footer hvac-p">
    <a routerLink="/change-password" class="hvac-text-link hvac-p-sm">{{'GENERAL.LABELS.CHANGE_PASSWORD' |
        translate}}</a>
    <button hvacButton="primary" [disabled]="!profileForm.valid || !profileForm.dirty || apiRequestActive" (click)="updateProfileInfo()"
        class='hvac-email-validation-submit-button'>
        <span>{{ 'USER_VALIDATION.SUBMIT'
            | translate }}</span>
        <utc-svg [src]="'assets/icons/arrow-white.svg'"></utc-svg>
    </button>
</div>

<div class="hvac-divider"></div>

<!-- TODO: get last login date -->
<!-- <p class="hvac-subtext">{{ 'PROFILE.LAST_LOGIN_DATE' | translate}}: {{dateService.formatDate(user?.lastLoginDate) ||
    '--'}}</p> -->
<hvac-email-validation *ngIf="enableEmailVerification$ | async"
    [requestEmail]="profileForm.controls.email.value"
    (emailVerification)="emailVerification($event)"
    (cancel)="cancelValidation($event)">
</hvac-email-validation>
